import { DrawerFullOptions } from '@/modules/Enums'

export default {
  // Préférences
  loader: { show: false, status: null },
  drawer: false,
  drawerOptions: DrawerFullOptions,
  networkType: null,
  usepassword: false,
  usevibrate: false,
  usebrightness: false,
  keepscreenon: false,
  usenfc: true,
  useqrcodes: true,
  usemanscan: true,
  duration: 30,
  offline: false,
  // Paramètres
  userId: '',
  merchantName: '',
  userName: '',
  teleparameters: null,
  creditPermissions: '',
  event: null,
  // App
  amount: 0,
  tipAmount: 0,
  donationAmount: 0,
  tipRef: null,
  donationRef: null,
  waiterNumber: 0,
  shops: [],
  listproducts: [],
  actionItems: null,
  menuItems: [],
  favoriteItem: null,
  favoriteScan: null,
  //
  transactions: {
    pax: 0,
    donation: 0,
    tips: 0,
    cashless: 0,
    cashlessCa: 0
  },
  //
  consignes: [],
  ecocup: {
    price: 100,
    idConsigne: 1,
    idDeconsigne: 2,
    consigne: 0,
    deconsigne: 0
  },
  //
  manageBankingTickets: false,
  printCustomerTicket: false,
  printMerchantTicket: false,
  neptingInfos: {
    merchantId: '',
    server: '',
    token: null,
    offline: 0
  },
  intent: {},
  printer: null,
  qrCodeUrl: null,
  campaignDeactivated: null
}
